import theme from '../../../const/theme'
import strings from '../../../locale/en'

const {
  menu: {
    admin: {
      dashboardMenu: { coachingCenters, branches }
    }
  }
} = strings

export const determineCoachingCenterOptions = () => {
  return {
    title: {
      text: coachingCenters
    },
    chart: {
      type: 'column'
    },
    series: [
      {
        name: coachingCenters,
        color: theme.dasboard.coachingCenter,
        events: {
          legendItemClick: function () {
            return false
          }
        },
        data: [
          {
            name: '1',
            y: 62.74,
            drilldown: '1',
            color: theme.dasboard.coachingCenter
          },
          {
            name: '2',
            y: 40.57,
            drilldown: '2',
            color: theme.dasboard.coachingCenter
          },
          {
            name: '3',
            y: 35.74,
            drilldown: '3',
            color: theme.dasboard.coachingCenter
          }
        ]
      }
    ]
  }
}

export const determineBranchesOptions = () => {
  return {
    title: {
      text: branches
    },
    chart: {
      type: 'column'
    },

    series: [
      {
        name: branches,
        color: theme.dasboard.branches,
        events: {
          legendItemClick: function () {
            return false
          }
        },
        data: [
          {
            name: '1',
            y: 62.74,
            drilldown: '1',
            color: theme.dasboard.branches
          },
          {
            name: '2',
            y: 25.57,
            drilldown: '2',
            color: theme.dasboard.branches
          },
          {
            name: '3',
            y: 40.74,
            drilldown: '3',
            color: theme.dasboard.branches
          }
        ]
      }
    ]
  }
}
